import { DekkingProps } from "./dekking";
import React, { ReactElement } from "react";
import { LabeledBevestigingInput } from "adviesbox-shared";
import { getAovTextResources } from "../infra/aov-resources";
import { UitkeringGedeeltelijkeAo } from "./uitkering-gedeeltelijke-ao";
import { cellFormatter } from "../../shared/utils/currency";

export const DekkingWgaGat = ({ selected, kenmerken, verzekerde, tarieven }: DekkingProps): ReactElement => {
  let bedrag = 0;
  if (!tarieven) {
    if (tarieven !== undefined) {
      bedrag = tarieven.sociaal.bedragMaxSvwDagInkomen;
    }
  }

  return (
    <>
      <UitkeringGedeeltelijkeAo kenmerken={kenmerken} selected={selected} verzekerde={verzekerde} />
      <LabeledBevestigingInput
        caption="Uitgebreid"
        name={`producten[${selected}].dekking.dekkingGegevensVerzekerde${verzekerde}.uitgebreid`}
        tooltip={getAovTextResources("uitgebreidToolTip").replace(
          "{tariefMaxDagInkomen}",
          tarieven && tarieven.sociaal ? cellFormatter(bedrag, 2, true) : "onbekend"
        )}
      />
    </>
  );
};
